import ApiUrl from "../../configTools/apiUrl";
const Get = (setValues)=>{
    fetch(ApiUrl.API_URL_Condition)
        .then(res=>res.json())
        .then(data =>{
            let ListSend = [];
            for (let index = 0; index < data.length; index++) {
            const element = data[index];
            ListSend.push({
                name: element.name,
                value: String(element.id)
            })
            }
            setValues(ListSend);
    });
}
export default {Get}